export default [
  {
    path: '/skema-ekspedisi',
    name: 'skema-ekspedisi',
    component: () => import('@/views/pages/komship/expeditions-schema/ExpeditionsSchema.vue'),
    meta: {
      navActiveLink: 'cod-biaya-ekspedisi',
      resource: 'Komship - Ekspedisi',
      action: 'read',
    },
  },
  {
    path: '/edit-biaya-ekspedisi',
    name: 'edit-biaya-ekspedisi',
    component: () => import('@/views/pages/komship/expeditions-schema/EditExpeditionFee.vue'),
    meta: {
      routeDetail: 'edit-biaya-ekspedisi',
      resource: 'Dashboard',
      action: 'read',
    },
  },
  {
    path: '/edit-biaya-ekspedisi-ro',
    name: 'edit-biaya-ekspedisi-ro',
    component: () => import('@/views/pages/komship/expeditions-schema/ROEditExpeditionFee.vue'),
    meta: {
      routeDetail: 'edit-biaya-ekspedisi',
      resource: 'Dashboard',
      action: 'read',
    },
  },
  // route & pages not used
  {
    path: '/biaya-ekspedisi',
    name: 'cod-biaya-ekspedisi',
    component: () => import('@/views/pages/ekspedisi/biaya/Index'),
    meta: {
      routeDetail: 'cod-biaya-ekspedisi-edit',
      resource: 'Komship - Ekspedisi',
      action: 'read',
    },
  },
  {
    path: '/biaya-ekspedisi/tambah',
    name: 'cod-biaya-ekspedisi-tambah',
    component: () => import('../../../views/pages/ekspedisi/biaya/TambahExpedisi/index'),
    meta: {
      navActiveLink: 'cod-biaya-ekspedisi',
      type: 'add',
      resource: 'Komship - Ekspedisi',
      action: 'read',
    },
  },
  {
    path: '/biaya-ekspedisi/daerah-tanpa-akses',
    name: 'cod-biaya-ekspedisi-daerah-tanpa-akses',
    component: () => import('@/views/pages/ekspedisi/biaya/DaerahTanpaAksesCOD/index'),
    meta: {
      navActiveLink: 'cod-biaya-ekspedisi',
      type: 'add',
      resource: 'Komship - Ekspedisi',
      action: 'read',
    },
  },
  {
    path: '/biaya-ekspedisi/daerah-tanpa-akses/upload',
    name: 'cod-biaya-ekspedisi-daerah-tanpa-akses-upload',
    component: () => import('@/views/pages/ekspedisi/biaya/UploadDokumen/index'),
    meta: {
      navActiveLink: 'cod-biaya-ekspedisi',
      type: 'add',
      resource: 'Komship - Ekspedisi',
      action: 'read',
    },
  },
  {
    path: '/biaya-ekspedisi/:shipping_id/edit',
    name: 'cod-biaya-ekspedisi-edit',
    component: () => import('../../../views/pages/ekspedisi/biaya/AturEkspedisi/index'),
    meta: {
      navActiveLink: 'cod-biaya-ekspedisi',
      type: 'edit',
      resource: 'Komship - Ekspedisi',
      action: 'read',
    },
  },
  // end route & pages not used
  {
    path: '/performa-ekspedisi',
    name: 'cod-performa-ekspedisi',
    component: () => import('@/views/pages/ekspedisi/performa/Index'),
    meta: {
      resource: 'Komship - Ekspedisi',
      action: 'read',
    },
  },
  {
    path: '/top-ongkir/detail/:ekspedisi',
    name: 'top-ongkir-detail',
    component: () => import('@/views/pages/ekspedisi/top-ongkir/Detail'),
    meta: {
      resource: 'Komship - Ekspedisi',
      action: 'read',
    },
  },
]
